// birthYear.js — age is COMPUTED from profiles.birth_year (2026-10-23), never
// stored. One place for the math, the ranges and the picker's options.
export const AGE_RANGES = ['18-24', '25-34', '35-44', '45-54', '55+'];

export const isValidBirthYear = (y, now = new Date()) => Number.isInteger(Number(y)) && Number(y) >= 1900 && Number(y) <= now.getFullYear();

/** Current year minus birth year, or null. */
export function ageFromBirthYear(birthYear, now = new Date()) {
  if (!isValidBirthYear(birthYear, now)) return null;
  return now.getFullYear() - Number(birthYear);
}

/** The reporting bucket for an age: '18-24' … '55+', 'under 18', or 'unknown'. */
export function ageRangeOf(age) {
  if (age == null || !Number.isFinite(Number(age))) return 'unknown';
  const a = Number(age);
  if (a < 18) return 'under 18';
  if (a <= 24) return '18-24';
  if (a <= 34) return '25-34';
  if (a <= 44) return '35-44';
  if (a <= 54) return '45-54';
  return '55+';
}

/** The one-time estimate for an existing user with a stored age (MATCHED PAIR with the migration). */
export const estimatedBirthYear = (age, now = new Date()) => (Number.isFinite(Number(age)) && age >= 5 && age <= 120) ? now.getFullYear() - Number(age) : null;

/** Picker options, newest first: 13 to 100 years old. */
export function birthYearOptions(now = new Date()) {
  const y = now.getFullYear();
  const out = [];
  for (let b = y - 13; b >= y - 100; b--) out.push(b);
  return out;
}
